import { Injectable } from '@angular/core';
import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';
import { Accordion, CmsComponentNodeData } from '@interfaces/index';
import { CmsComponentConfig,TextMediaBox } from '@interfaces/config';
import { AccordionItemsDataInner, ParagraphAccordionData, ParagraphAccordionItemData } from '@generated/content';
import {
  
  MediaImageData
 
} from '@generated/content';
import { TMediaNodeType } from '@interfaces/media';

import {  CmsComponentTypeEnum, MediaTypesEnum } from '@models/enums';
import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';
@Injectable({
  providedIn: 'root',
})
export class AccordionComponentResolver extends BaseComponentResolver {
  static override instance: AccordionComponentResolver;
  private readonly componentType = Accordion.TypeEnum;

  static getInstance(): AccordionComponentResolver {
    return (AccordionComponentResolver.instance ||= new AccordionComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphAccordionData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<Accordion.ComponentConfig> | null {
    if (!node) {
      return null;
    }

    this.nodePageData = nodePageData;
 
    return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        headline: this.hyphenate(node.attributes.field_headline_accordion),
        description: this.hyphenate(node.attributes.field_summary_accordion?.value),
        items: this.getAccordionItems(node),
      },
    };
  }

  private getAccordionItems(node: ParagraphAccordionData): Accordion.AccordionItemConfig[] {
    if (!node.relationships.field_accordion_items?.data?.length) {
      return [];
    }

    return node.relationships.field_accordion_items.data.map(item => this.buildAccordionItemConfig(item));
  }

  private buildAccordionItemConfig(node: AccordionItemsDataInner): Accordion.AccordionItemConfig | null {

    const { id, type } = node;

    if (!(id && node)) {
      return null;
    }

    const accordionItemNode = this.getNode<ParagraphAccordionItemData>(id, type);

    if (!accordionItemNode) {
      return null;
    }
    let description:any = "";
    if(accordionItemNode.attributes.field_text_accordion_item && "processed" in accordionItemNode.attributes.field_text_accordion_item &&accordionItemNode.attributes.field_text_accordion_item.processed!=null ){
      description = accordionItemNode.attributes.field_text_accordion_item.processed;
    }
    
    let media;
    if(accordionItemNode.relationships?.field_image?.data){
      media = ( this.buildColumnConfig(accordionItemNode.relationships.field_image.data))
    }


    return {
      headline: this.hyphenate(accordionItemNode.attributes.field_headline_accordion_item),
      subheadline: this.hyphenate(accordionItemNode.attributes?.field_subheadline_accordion_item?.value),
      description: this.hyphenate(description.trim()),
      active: false,
      media
    };
  }


    private buildColumnConfig(node: any): TextMediaBox.MediaImageConfig | null {
    
      const { id, type } = node;
    
      if (!(id && node)) {
        return null;
      }
  
   
      const columnNode = this.getNode<MediaImageData>(id, type);
  
  
      if (!columnNode) {
        return null;
      }
  
       const media = this.getMediaConfig(columnNode);
  
      return  media;
  
  
    }
  
  
  
        private getMediaConfig(
          node: MediaImageData
        ):
           TextMediaBox.MediaImageConfig
          {
            
        
   
          const { type, id } = node;
      
          
        
          switch (type) {
            case MediaImageData.TypeEnum.MediaImage:
              const { dataUrls, metas } = this.getMediaDataUrls(id, type as TMediaNodeType, null, true);
              return {
                type: MediaTypesEnum.IMAGE,
                dataUrls,
                metas,
                fill: false,
                sizes: MediaResolver.buildImageConfigSizes(CmsComponentTypeEnum.TEXT_MEDIA_BOX),
              };
      
           
      
            default:
              return null;
          }
        }
      
}
